import Text from "../Text";
import React from 'react';
var ContactDesktop = function (_a) {
    var label = _a.label, phone = _a.phone, phoneHref = _a.phoneHref;
    return (React.createElement(React.Fragment, null,
        React.createElement(Text, { fontWeight: "medium" }, label),
        React.createElement("a", { href: "tel:".concat(phoneHref || phone) },
            React.createElement(Text, { fontWeight: "bold" }, phone))));
};
export default ContactDesktop;
//# sourceMappingURL=ContactMobile.js.map